interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Cosmos = ({ ...props }: IconProps) => (
  <svg
    width="70"
    height="80"
    viewBox="0 0 70 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.290424 60.003C2.75655 64.2716 20.263 58.7852 39.3953 47.7333C58.5276 36.6875 72.0395 24.2716 69.5734 19.997C67.1073 15.7284 49.6008 21.2209 30.4685 32.2667C11.3362 43.3125 -2.1757 55.7284 0.290424 60.003ZM68.0146 20.9042C69.9814 24.3142 56.7678 35.634 38.4941 46.1805C20.2204 56.7271 3.81607 62.5179 1.84317 59.1079C-0.123642 55.698 13.0899 44.3781 31.3636 33.8316C49.6374 23.2851 66.0417 17.4943 68.0146 20.9042Z"
      fill="white"
    />
    <path
      d="M0.290424 19.997C-2.1757 24.2655 11.3362 36.6875 30.4685 47.7333C49.6008 58.7791 67.1073 64.2716 69.5734 60.003C72.0395 55.7345 58.5276 43.3125 39.3953 32.2667C20.263 21.2209 2.75655 15.7284 0.290424 19.997ZM68.0146 59.0958C66.0478 62.5057 49.6374 56.721 31.3636 46.1684C13.0899 35.6219 -0.123642 24.302 1.84317 20.8921C3.80999 17.4821 20.2204 23.2669 38.4941 33.8195C56.7678 44.366 69.9814 55.6858 68.0146 59.0958Z"
      fill="white"
    />
    <path
      d="M34.9319 0C29.9997 0 25.9991 17.9084 25.9991 40C25.9991 62.0916 29.9997 80 34.9319 80C39.8642 80 43.8648 62.0916 43.8648 40C43.8648 17.9084 39.8642 0 34.9319 0ZM34.9319 78.2037C30.9922 78.2037 27.8015 61.0991 27.8015 40C27.8015 18.9009 30.9922 1.79632 34.9319 1.79632C38.8716 1.79632 42.0624 18.9009 42.0624 40C42.0624 61.0991 38.8716 78.2037 34.9319 78.2037Z"
      fill="white"
    />
    <path
      d="M34.9319 44.7008C37.5281 44.7008 39.6328 42.5961 39.6328 39.9999C39.6328 37.4037 37.5281 35.299 34.9319 35.299C32.3357 35.299 30.2311 37.4037 30.2311 39.9999C30.2311 42.5961 32.3357 44.7008 34.9319 44.7008Z"
      fill="white"
    />
    <path
      d="M12.341 32.3397C12.341 33.8985 11.0744 35.1651 9.51558 35.1651C7.95674 35.1651 6.69019 33.8985 6.69019 32.3397C6.69019 30.7808 7.95674 29.5143 9.51558 29.5143C11.0744 29.5143 12.341 30.7808 12.341 32.3397Z"
      fill="white"
    />
    <path
      d="M31.7229 65.8547C31.7229 67.4135 30.4564 68.6801 28.8975 68.6801C27.3387 68.6801 26.0721 67.4135 26.0721 65.8547C26.0721 64.2958 27.3387 63.0293 28.8975 63.0293C30.4564 63.0293 31.7229 64.2958 31.7229 65.8547Z"
      fill="white"
    />
    <path
      d="M57.121 21.848C57.121 23.4068 55.8544 24.6734 54.2956 24.6734C52.7368 24.6734 51.4702 23.4068 51.4702 21.848C51.4702 20.2891 52.7368 19.0226 54.2956 19.0226C55.8544 19.0226 57.121 20.2891 57.121 21.848Z"
      fill="white"
    />
  </svg>
);
